export default "__VITE_ASSET__eIsab7Zp__"